<div class="a-datepicker"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional">
  <div class="a-input__optional" *ngIf="isOptional">Optional</div>
  <input
    ngxDaterangepickerMd
    placeholder=" "
    opens="left"
    startKey="start"
    endKey="end"
    [showClearButton]="true"
    [ngModel]="dateRange"
    [locale]="locale"
    (clearClicked)="clearClicked()"
    (datesUpdated)="datesUpdated($event)"
    [class.has-error]="control.invalid">
  <label>{{ label }}</label>
  <i class="app-ico-mask app-ico-mask__x" 
    *ngIf="control.value && control.value.start" 
    (click)="clear()">
  </i>
  <i class="app-ico-mask app-ico-mask__calendar ngx-daterangepicker-action" 
    *ngIf="!control.value || (control.value && !control.value.start)"
    (click)="openDatepicker()">
  </i>
</div>